export default __webpack_public_path__ + "static/media/creative-2.ab4989d8.gif";